<!-- <app-fire-foresight-menu></app-fire-foresight-menu> -->

<div id="content" class="app-content">

    <div class="container-fluid px-2">
        <!-- PAGE-HEADER -->
        <div class="row">
            <div class="col-12">
                <!-- <h1 class="h1">Fire Foresight Command Centre</h1> -->
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-8">
                <!--MAP-->
                <div class="card cc-cyber-card">
                    <div class="cc-cyber-header d-flex justify-content-between align-items-center">
                        <span class="flex-grow-1">Tactical Map</span>
                        <a (click)="toggleCameras()" style="cursor: pointer;" class="cc-map-action me-2" [title]="camerasSelected ? 'Hide cameras' : 'Show cameras'">
                            <i [ngClass]="{'bi-camera-video': !camerasSelected, 'bi-camera-video-fill': camerasSelected}" class="bi"></i>
                        </a>
                        <a (click)="toggleIncidents()" style="cursor: pointer;" class="cc-map-action me-2" [title]="incidentsSelected ? 'Hide incidents' : 'Show incidents'">
                            <i class="bi bi-fire" [style.color]="incidentsSelected ? '#ff5000' : ''"></i>
                        </a>
                        <a (click)="toggleLayers()" style="cursor: pointer;" class="cc-map-action" [title]="layersSelected ? 'Hide layers' : 'Show fire layers'">
                            <i [ngClass]="{'bi-layers': !layersSelected, 'bi-layers-fill': layersSelected}" class="bi"></i>
                        </a>
                    </div>
                    <div class="p-0">
                        <app-command-centre-map #commandMap mapheight="700px" [cameraSegmentCounts]="cameraSegmentCounts"
                            (mapReady)="onMapReady($event)"
                            (segmentClicked)="onSegmentClicked($event)">
                        </app-command-centre-map>
                    </div>
                </div>
            </div>

            <div class="col-4 d-flex flex-column gap-2" style="height:740px; min-height:740px;">
                <!-- Image Feed -->
                <div class="card cc-cyber-card " style="min-height:374px;">
                    <div class="cc-cyber-header d-flex justify-content-between align-items-center flex-shrink-0">
                        <span class="flex-grow-1 text-truncate me-2" [title]="activeImageFeedLabel">{{activeImageFeedLabel}}</span>
                        <div class="spinner-border spinner-border-sm text-primary me-2" role="status" *ngIf="imageFeedLoading"></div>
                        <div class="btn-group btn-group-sm me-2" *ngIf="activeImageFeedUri && !imageFeedLoading">
                            <button class="btn btn-xs cc-period-btn" [class.active]="imageFeedPeriod === '-1h:1h'"  (click)="imageFeedPeriod = '-1h:1h';  loadImageFeed(activeImageFeedUri, '-1h:1h')">1h</button>
                            <button class="btn btn-xs cc-period-btn" [class.active]="imageFeedPeriod === '-4h:1h'"  (click)="imageFeedPeriod = '-4h:1h';  loadImageFeed(activeImageFeedUri, '-4h:1h')">4h</button>
                            <button class="btn btn-xs cc-period-btn" [class.active]="imageFeedPeriod === '-24h:1h'" (click)="imageFeedPeriod = '-24h:1h'; loadImageFeed(activeImageFeedUri, '-24h:1h')">24h</button>
                        </div>
                        <a *ngIf="activeImageFeedUri" (click)="activeImageFeedUri = null; imageFeedImages = []" style="cursor:pointer" class="cc-map-action flex-shrink-0" title="Close">
                            <i class="bi bi-x-lg"></i>
                        </a>
                    </div>
                    <div *ngIf="imageFeedImages?.length" class="p-0 flex-grow-1" style="min-height:0;">
                        <smart-image-list [images]="imageFeedImages"></smart-image-list>
                    </div>
                    <div *ngIf="!imageFeedImages?.length && !imageFeedLoading" class="card-body d-flex align-items-center justify-content-center cc-muted flex-grow-1" style="font-family:monospace;font-size:0.8rem">
                        {{activeImageFeedUri ? 'No images found' : 'Select a camera segment'}}
                    </div>
                </div>

                <!-- Incident Feed -->
                <div class="card cc-cyber-card flex-grow-1 d-flex flex-column" style="min-height:0;">
                    <div class="cc-cyber-header d-flex justify-content-between align-items-center flex-shrink-0">
                        <span>Incident Feed</span>
                        <span class="cc-muted" style="font-size:0.7rem">LIVE</span>
                    </div>
                    <div class="flex-grow-1" style="min-height:0; overflow:hidden;">
                        <app-incident-feed (incidentRefreshed)="onIncidentRefreshed($event)"></app-incident-feed>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-12">
                <div class="card" [ngClass]="{'card-expand':false, 'bg-emphasis':!false}">
                    <div class="card-body p-2 m-3px">

                        <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase">
                            <span class="flex-grow-1">Name</span>
                            <a class="text-default text-opacity-75 text-decoration-none" data-bs-original-title=""
                                title=""><i class="bi bi-arrow-repeat"></i></a>
                            <a class="text-default text-opacity-75 text-decoration-none" data-bs-original-title=""
                                title=""><i class="bi bi-fullscreen"></i></a>
                        </div>
                        <div class="card-body p-2 m-3px">
                            DATABUS TELEMETRY HERE
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <!-- Device Activity Matrix -->
            <div class="col-6">
                <div class="card cc-cyber-card">
                    <div class="cc-cyber-header d-flex justify-content-between align-items-center">
                        <span>Device Activity</span>
                        <!-- <span class="cc-pulse-indicator" [class.cc-pulse-offline]="!mqtt.connected" [title]="mqtt.connected ? 'MQTT connected' : 'MQTT disconnected'"></span> -->
                    </div>
                    <div class="cc-matrix-scroll">
                        <table class="table table-borderless table-sm mb-0 cc-matrix-table">
                            <thead>
                                <tr>
                                    <th>Device</th>
                                    <th>Last Topic</th>
                                    <th class="text-end">Last Seen</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let d of deviceActivities"
                                    [class.cc-row-offline]="d.offline"
                                    [class.cc-row-stale]="d.stale"
                                    [class.cc-row-selected]="selectedDeviceFilter === d.deviceId"
                                    (click)="selectedDeviceFilter = selectedDeviceFilter === d.deviceId ? null : d.deviceId"
                                    style="cursor:pointer">
                                    <td class="text-truncate" style="max-width:120px" [title]="d.deviceName">{{d.deviceName}}</td>
                                    <td class="cc-topic text-truncate" style="max-width:100px" [title]="d.lastTopic">{{d.lastTopic}}</td>
                                    <td class="text-end cc-muted">{{d.lastSeenLabel}}</td>
                                </tr>
                                <tr *ngIf="deviceActivities.length === 0">
                                    <td colspan="3" class="cc-muted text-center">Awaiting data…</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Raw Telemetry Stream -->
            <div class="col-6">
                <div class="card cc-cyber-card">
                    <div class="cc-cyber-header d-flex justify-content-between align-items-center">
                        <span>Telemetry Stream</span>
                        <span *ngIf="selectedDeviceFilter" class="cc-filter-badge" (click)="selectedDeviceFilter = null" title="Clear filter">
                            {{selectedDeviceFilter | slice:0:12}}… <i class="bi bi-x"></i>
                        </span>
                        <span *ngIf="!selectedDeviceFilter" class="cc-muted" style="font-size:0.7rem">ALL DEVICES</span>
                    </div>
                    <div class="cc-terminal">
                        <div *ngFor="let entry of filteredLog" class="cc-log-line">
                            <span class="cc-ts">{{entry.timestamp | date:'HH:mm:ss.SSS'}}</span>
                            <span class="cc-topic">[{{entry.topic}}]</span>
                            <span class="cc-payload">{{entry.payload}}</span>
                        </div>
                        <div *ngIf="filteredLog.length === 0" class="cc-muted">
                            Awaiting telemetry…
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>